const windowAccessor: any = window;
const externalOptions: any = windowAccessor.wmctOptions || {};

const options: IConfiguration = Object.assign({
	CourseAtlasUrl: 'https://services.courseatlas.com/odata/v2/',
	ApiUrl: 'https://collegetransferapiqa.azurewebsites.net/v1/',
	ApiKey: 'A6462E15-EC01-4B73-82E5-6C766ED13BBB',
	TargetUnitId: '000001',
	Dark: false,
	HttpReferrer: null,
	ShowPoweredBy: true,
}, externalOptions);

export interface IConfiguration {
	CourseAtlasUrl: string;
	ApiUrl: string;
	ApiKey: string;
	TargetUnitId: string;
	Dark: boolean;
	HttpReferrer: string | null;
	ShowPoweredBy: boolean;
}

export default options;
